import React from 'react'

class Emoji extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 40 40">
        <text y="32" font-size="32">
          😀
        </text>
      </svg>
    )
  }
}

export default Emoji
